$(document).on('init:user_messages.nearme', function() {
  require.ensure('../controllers/messages_controller', function(require) {
    var MessagesController = require('../controllers/messages_controller');
    return new MessagesController($('[data-messages-form]'));
  });
});

var els = $('[data-messages-form]');
if (els.length > 0) {
  require.ensure('../controllers/messages_controller', function(require) {
    var MessagesController = require('../controllers/messages_controller');
    els.each(function() {
      return new MessagesController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/messages.initializer.js